/* Product-specific values come from #inventory-time-config in the PDP HTML. */
(function () {
  var configEl = document.getElementById("inventory-time-config");
  if (!configEl) return;
  var cfg = JSON.parse(configEl.textContent);
  var productId = cfg.productId;


  var PDP_LIGHTNING_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16" width="7" height="9" aria-hidden="true"><path fill="currentColor" d="M7.1.55 1.05 8.7h3.85L3.7 15.45 10.95 6.7H6.85L7.1.55Z"/></svg>';

  var PDP_INV_ICONS = {
    ship: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7.5h9.5A1.5 1.5 0 0 1 14 9v7.5H3.75A1.75 1.75 0 0 1 2 14.75v-5.5A1.75 1.75 0 0 1 3.75 7.5H3Zm11 3h3.1c.4 0 .77.2 1 .53l2.15 3.07c.2.28.3.62.3.96V16.5a1 1 0 0 1-1 1h-.35" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7.25" cy="17.5" r="1.75" stroke="currentColor" stroke-width="1.6"/><circle cx="17" cy="17.5" r="1.75" stroke="currentColor" stroke-width="1.6"/><path d="M9 17.5h6.25" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    express: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M8 3.5v3M16 3.5v3M3.5 9.5h17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M8.5 13.5h3.2M8.5 16.5h7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    pickup: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4.5 10.2 12 4.5l7.5 5.7V19a1.5 1.5 0 0 1-1.5 1.5h-3.75v-5.25h-4.5V20.5H6A1.5 1.5 0 0 1 4.5 19v-8.8Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8.25" stroke="currentColor" stroke-width="1.6"/><path d="M12 11v5.25M12 8.25h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
  };

  /* Presentation only: keep original copy, just wrap each line with an icon. */
  function k_render_inventory_note(html) {
    if (!html) return '';
    if (String(html).indexOf('pdp-inventory-note__row') !== -1) return html;

    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var rows = [];

    wrap.querySelectorAll('p').forEach(function (p) {
      var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      var kind = 'info';
      if (/Ship within/i.test(text)) kind = 'ship';
      else if (/Express shipping/i.test(text)) kind = 'express';
      else if (/pickup/i.test(text)) kind = 'pickup';

      rows.push(
        '<div class="pdp-inventory-note__row pdp-inventory-note__row--' + kind + '">' +
          '<span class="pdp-inventory-note__icon" aria-hidden="true">' +
            (PDP_INV_ICONS[kind] || PDP_INV_ICONS.info) +
          '</span>' +
          '<div class="pdp-inventory-note__text">' + p.innerHTML.trim() + '</div>' +
        '</div>'
      );
    });

    return rows.join('');
  }

  function k_patch_inventory_set_text() {
    if (typeof k_set_text !== 'function') {
      window.setTimeout(k_patch_inventory_set_text, 50);
      return;
    }
    if (k_set_text.__inventoryPatched) return;

    var original = k_set_text;
    function patched(selector, html, color) {
      if (selector === 'stock_text_v1' && (color == null || typeof color === 'undefined')) {
        html = k_render_inventory_note(html);
      }
      return original(selector, html, color);
    }
    patched.__inventoryPatched = true;
    k_set_text = patched;
    window.k_set_text = patched;
  }

  k_patch_inventory_set_text();

   /**
    * 为颜色选项添加标签
    * @param {string} colorValue - 颜色的值，例如 "Red"
    * @param {string} labelText - 要添加的标签内容
    */
function addColorLabelsToOptions(colorValue, labelText) {
     if (!colorValue || !labelText) return;

      colorValue = colorValue.replace(/_/g, ' ');

     // 查找所有匹配给定颜色值的选项元素
     document.querySelectorAll('.lv-option-item[data-value="' + colorValue + '"]').forEach(function(item) {
       // 找到该选项内的swatch元素
       const swatchDiv = item.querySelector('.lv-option-swatch');
       if (swatchDiv) {
         // 检查是否已经包含了标签文本，避免重复添加
         if (swatchDiv.innerHTML.indexOf(labelText) === -1) {
           // 直接添加标签文本，保持和示例相同的格式
           swatchDiv.innerHTML = swatchDiv.innerHTML + ' ' + labelText;
         }
       }
     });
   }

  /**
   * 为图片色块选择器添加蒙层和闪电标
   * 适用于 .f-thumb__list 下通过 img[data-color] 展示颜色的情况
   * @param {string} colorValue - 颜色值，例如 "Yellow" 或 "Sky_Blue"
   */
  function addColorLabelsToImageSwatches(colorValue) {
    if (!colorValue) return;

    colorValue = colorValue.replace(/_/g, ' ');

    document.querySelectorAll('.f-thumb__list img[data-color="' + colorValue + '"]').forEach(function(img) {
      var label = img.closest('label.f-thumb__list__link');
      if (!label) return;
      if (label.querySelector('.f-thumb-lightning-overlay')) return;

      var overlay = document.createElement('div');
      overlay.className = 'f-thumb-lightning-overlay';
      overlay.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" class="icon-x" width="13" height="17" viewBox="0 0 15 20" aria-hidden="true"><path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8" fill="none" stroke="#FFFFFF" stroke-width="1"></path></svg>';
      label.appendChild(overlay);
    });
  }


   
   /**
    * 获取产品ID和颜色信息
    * @returns {Array} 包含产品ID和颜色的数组
    */
function getProductColors() {
  // Get the data from the script tag with ID "lv-option-product-group-data"
  const scriptElement = document.getElementById('lv-option-product-group-data');
  
  if (!scriptElement) {
    return [];
  }
  
  try {
    // Parse the JSON data from the script element
    const data = JSON.parse(scriptElement.textContent);
    
    // Check if the necessary data exists
    if (!data || !data.value || !data.value.products) {
      return [];
    }
    
    // Map the products to the required format
    return data.value.products.map(product => ({
      id: product.id,
      color: product.value.replace(/ /g, '_'), // 将空格替换为下划线
      colorCode: product.color
    }));
  } catch (error) {
    console.error('Error parsing product color data:', error);
    return [];
  }
}

   
       
   /**
    * 获取产品库存信息
    * @param {Array} productIds - 产品ID数组
    * @returns {Promise<Array>} 包含产品库存信息的数组
    */
   async function getProductInventory(productIds) {
     if (!productIds || !productIds.length) return [];

     var concurrency = 2;
     var results = new Array(productIds.length);
     var nextIndex = 0;

     async function fetchOne(id) {
       try {
         var response = await fetch(
           'https://api.kissprom.com/node/api/sitemap?name=product&id=' + id + '&store=4'
         );
         if (!response.ok) throw new Error('HTTP error! status: ' + response.status);
         var data = await response.json();
         return data.data;
       } catch (error) {
         console.error('获取产品 ' + id + ' 库存信息失败:', error);
         return null;
       }
     }

     async function worker() {
       while (nextIndex < productIds.length) {
         var current = nextIndex;
         nextIndex += 1;
         results[current] = await fetchOne(productIds[current]);
       }
     }

     try {
       var workers = [];
       for (var i = 0; i < Math.min(concurrency, productIds.length); i++) {
         workers.push(worker());
       }
       await Promise.all(workers);

       var mergedData = {};
       results.forEach(function (result) {
         if (result) Object.assign(mergedData, result);
       });
       return mergedData;
     } catch (error) {
       console.error('获取库存信息失败:', error);
       return {};
     }
   }

   /**
    * 获取产品信息和库存的完整示例
    * @returns {Promise<Array>} 包含产品信息和库存的数组
    */
   async function getProductInfoAndInventory() {
     // 1. 首先获取产品颜色信息
     const productColors = getProductColors();

  
     
     if (!productColors.length) {
       console.log('未找到产品信息');
       return [];
     }

     // 2. 提取产品ID
     const productIds = productColors.map(item => item.id);
     // 3. 获取库存信息
     try {
       const inventory = await getProductInventory(productIds);
           //console.log('tttttttttttttttttttttttttttttttttttttt55555555555555555tttt',inventory)
        // 4. 合并产品颜色和库存信息
         const result = {};
         productColors.forEach(colorInfo => {
           result[colorInfo.color] = inventory[colorInfo.color] || {};
         });
         
         return result;
     } catch (error) {
       console.error('获取库存信息失败:', error);
       return productColors; // 如果获取库存失败，至少返回颜色信息
     }
   }

 var apiData = null;
 var likui_num=null;
 var k_api_retry_count = 0;
 var K_API_RETRY_MAX = 20; // ~10s max wait for inventory API

 function k_schedule_when_idle(fn, timeout) {
   if (typeof window.requestIdleCallback === 'function') {
     window.requestIdleCallback(fn, { timeout: timeout || 2500 });
   } else {
     window.setTimeout(fn, 1200);
   }
 }

   document.addEventListener('DOMContentLoaded', function() {
     // Defer third-party inventory API until after first paint / idle so it
     // does not compete with LCP images and PDP JS.
     k_schedule_when_idle(async function() {
           var datas = await getProductInfoAndInventory();
     
          //console.log('55555555555522222222222222222225555555555', datas);
           
           // 获取颜色数量
           var colorCount = Object.keys(datas).length;
           
           if (colorCount > 1) {
             // 如果有多个颜色，使用 datas 的值
             apiData = datas;
             k_api_retry_count = 0;
             k_set_icon();
           } else {
             // 如果只有一个颜色，使用原来的 API 调用
             var productId = cfg.productId;
             var apiUrl = `https://api.kissprom.com/node/api/sitemap?name=product&id=${productId}&store=4`;
             
             // 使用 fetch 请求 API 数据
             fetch(apiUrl)
               .then(response => response.json())
               .then(data => {
                 //console.log('API Response:', data);
                 apiData = data['data']; // 将数据存储到全局变量
                // console.log('66666666666666666666', apiData);
                 k_api_retry_count = 0;
                 k_set_icon();
               })
               .catch(error => {
                 console.error('Error fetching API:', error);
               });
           }
     }, 2500);
   });

     var  size_list_json=cfg.sizeValues;
     var  color_list_json=cfg.colorValues;
     window.size_list_json = size_list_json;
     window.color_list_json = color_list_json;

    var productVariantInventoryData = cfg.variants;

    window['product_inven_array_' + productId] = {};
    window['product_inven_c_' + productId] = {};
    window['product_inven_size_' + productId] = {};
    window['product_sku_array_' + productId] = {};

    Object.keys(productVariantInventoryData).forEach(function(variantId) {
      var variantData = productVariantInventoryData[variantId];
      window['product_inven_array_' + productId][variantId] = variantData.inventory;
      window['product_inven_c_' + productId][variantId] = variantData.color;
      window['product_inven_size_' + productId][variantId] = variantData.size;
      window['product_sku_array_' + productId][variantId] = variantData.sku;
    });

    window['product_tag_array_' + productId] = cfg.tags;

     function k_set_icon() {
       var product_sku_id = cfg.firstVariantId;       
       var skuid=k_get_ids(product_sku_id);
     
      var kcid=k_get_Stock(window['product_inven_array_' + productId],'variant');
      var productid=String(productId);
      var cols = window['product_inven_c_' + productId]; 
      var  size = window['product_inven_size_' + productId]; 

     
      var data_list_id=cols[skuid];
      var data_sizeid=size[skuid];
    
      if(apiData!=null){
        
    
              var col_list=apiData;
              var arrays=apiData[data_list_id];

              // 将当前颜色下可立即发货的尺码写入全局，供尺码下拉组件读取
              var _shipsNowArr = [];
              for (var _sk in arrays) { if (arrays[_sk] == 1) _shipsNowArr.push(_sk); }
              window.currentSkuMarker = { size: _shipsNowArr };
              document.dispatchEvent(new CustomEvent('inventoryTimeReady'));

               for (var c in col_list) {
                 let content = ''; // 根据 i 的值来决定 content 的内容
                 if (Object.values(col_list[c]).includes(1)) {
                      //content = '<svg t="1735091021200" class=" icon" style="width:60%;height:60%" t="1735041761661"  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6939" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200"><path d="M219.664444 959.052802l-0.013303 0c-10.434653 0-19.771299-4.857635-25.595958-13.293771-10.42135-15.096836-4.28356-33.719986-1.450025-41.320081L279.698748 582.192665c0.234337-0.88823 0.521886-1.750877 0.849344-2.599198 0.12996-0.326435 0.234337-0.64059 0.313132-0.927115-0.12996 0-0.260943 0-0.417509 0l-52.316529 0c-19.902282 0-36.304857-8.462742-44.989657-23.218818-8.762571-14.888082-8.148587-33.589003 1.671059-51.310619L401.346319 114.195855C416.65191 86.522586 451.886389 65.627696 483.281423 65.627696l314.848805 0c20.841677 0 37.074384 8.789177 44.518936 24.133653 7.483438 15.423271 4.284583 33.785477-8.774851 50.370201l-223.655849 285.164738 95.503121 0c31.447223 0 41.203424 17.486256 43.932582 24.995277 2.715855 7.483438 6.438643 26.968212-17.21201 47.15702l-480.037031 446.611757c-0.326435 0.314155-0.666172 0.626263-1.019213 0.913812C239.958652 954.561511 229.877039 959.052802 219.664444 959.052802zM331.021647 597.301781l-72.414263 267.932262L673.974533 478.787574l-79.492472 0c-20.843724 0-37.07643-8.789177-44.519959-24.108071-7.496741-15.423271-4.296863-33.797757 8.761548-50.409087l223.655849-285.151435L483.281423 119.118981c-11.872399 0-29.29214 10.408047-35.156708 20.999266L234.317165 525.174044l46.125527 0c19.131733 0 35.71748 8.149611 45.485961 22.358217C335.540567 561.506531 337.369216 579.565838 331.021647 597.301781z" fill="#c16452" p-id="6940"></path><path d="M384.551818 385.387347c-2.193968 0-4.41352-0.535189-6.477528-1.684362-6.450922-3.578502-8.789177-11.727089-5.197372-18.179035l11.988032-21.586644c3.578502-6.451946 11.727089-8.81476 18.179035-5.197372 6.464225 3.578502 8.789177 11.727089 5.197372 18.179035l-11.988032 21.586644C393.811716 382.90583 389.25391 385.387347 384.551818 385.387347zM422.3067 317.386604c-2.193968 0-4.41352-0.535189-6.477528-1.684362-6.451946-3.578502-8.789177-11.727089-5.198395-18.179035l56.625672-101.968369c11.597129-20.947078 39.269375-37.375236 63.012126-37.375236l34.973536 0c7.391341 0 13.372565 5.981225 13.372565 13.372565 0 7.392364-5.982248 13.372565-13.372565 13.372565l-34.973536 0c-14.156418 0-32.661887 11.022031-39.622416 23.598464l-56.625672 101.980649C431.565575 314.905086 427.008792 317.386604 422.3067 317.386604z" fill="#c16452" p-id="6941"></path></svg>';
                   content = PDP_LIGHTNING_SVG;
                   var tows = '<span class="cor_num z-5">'+content+'</span>';
                   // console.log('bbbbbbbbbbbbbbbbbbbb')
                   addColorLabelsToOptions(c,tows)
                   addColorLabelsToImageSwatches(c)
                 }
                  document.querySelectorAll('.c_kui_'+c).forEach(function(element) {
                                 element.innerHTML = content;
                  });
              }
        

              for (var si in arrays) {
                  let content = ''; // 根据 i 的值来决定 content 的内容
                  if (arrays[si]==1) {
                    content = PDP_LIGHTNING_SVG;
                  }
                  document.querySelectorAll('.size_kui_'+si).forEach(function(element) {
                                 element.innerHTML = content;
                  });
              }

              likui_num = apiData[data_list_id][data_sizeid];
        
      }else{
          if (k_api_retry_count >= K_API_RETRY_MAX) return;
          k_api_retry_count += 1;
          setTimeout(function() {
                k_set_icon();
          }, 500);
      }

   }

        
              
   function k_stock_text() {

       if(apiData==null){
              if (k_api_retry_count >= K_API_RETRY_MAX) return;
              k_api_retry_count += 1;
              setTimeout(function() {
                    k_stock_text();
              }, 500); 
              return
       }
       k_api_retry_count = 0;

       setTimeout(function() {
 
                    k_set_icon();
                 
            		//var kcid=k_get_Stock(window['product_inven_array_' + productId],'variant');
                   
                    var ksku=k_get_Stock(window['product_sku_array_' + productId],'variant');   
                    if(ksku==null){iscus=false;}                      
                    else{
                      ksku=ksku.toUpperCase();
                      iscus=ksku.endsWith('C');
                    }                                         
         
                    var kcid=likui_num==1?1:0;                  
         
                    var ktags = Object.keys(window['product_tag_array_' + productId]);                                                                     
                    //var ktag=window['product_tag_array_' + productId][ktags[0]];   
                    var knew=''
                    var klong=''
                    var kplus=''
                    var kgs=''
                    for (v of ktags) {
                      if (v=='New-Trial') {
                        knew='New';
                      }
                      if (v=='Long-Term') {
                        klong='Long';
                      }
                      if (v=='long-term-plus') {
                        kplus='Plus';
                      }
                      if (v=='delay-term') {
                        kplus='Delay';
                      }
                      if (v=='Graduation dresses') {
                        kgs='Graduation';
                      }
                    }          
                   if(kcid==null){
                       var keys = Object.keys(window['product_inven_array_' + productId]);
                     
                        kcid=window['product_inven_array_' + productId][keys[0]];

                   }
  
                    var time=k_time();

        
                   var v1 = get_k_data('stock_text_v2','numv1');
                   var v2 = get_k_data('stock_text_v2','numv2');
                   v1 = Number(v1);
                   v2 = Number(v2);
           //console.log('--------------------------------------1---------------------------',ksku,kcid,v1,v2)
                     k_set_style('stock_ico_v1','display: none;');
                     k_set_style('stock_ico_v2','display: none;');    
                     k_set_style('stock_text_v1','display: none;');
                     k_set_style('stock_text_v2','display: none;');
            		     k_set_text('stock_text_v1','');
                     k_set_text('stock_text_v2','');
                     //k_set_text('stock_text_v3','');
                    
                    

                    if (iscus==true) {

                    if(kcid < 1){
                       //k_set_style('stock_ico_v1','display: flex;background: #faf2e6;text-indent:30px;');
                       k_set_style('stock_text_v1','display: block;');                       
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: block;color: #AB6803;background: #faf2e6;');
                       //k_set_style('stock_text_v3','display: block;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv5'))+' – '+k_time(get_k_data('stock_text_v2','numv6')));                        
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                 //+' Store </P><P>In-person pickup not available </p>'
                                 //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c3(get_k_data('stock_text_v2','numv5'))+' – '+k_time_c3(get_k_data('stock_text_v2','numv6'))+' </span></p>'
                                 '<p>In-person pickup is currently unavailable</p>'
                                 +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv5'))+' – '+k_time_c(get_k_data('stock_text_v2','numv6'))+'</span></p>');                                                                  
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv5'))+' – '+k_time(get_k_data('stock_text_v2','numv6')));
                       //k_set_text('stock_text_v3','');
            		}

                    if (kplus=='Delay'){
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                  //+' Store </P><P>In-person pickup not available </p>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c3(get_k_data('stock_text_v2','numv12'))+' – '+k_time_c3(get_k_data('stock_text_v2','numv13'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv12'))+' – '+k_time_c(get_k_data('stock_text_v2','numv13'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv9'))+' – '+k_time(get_k_data('stock_text_v2','numv0'))); //new
                       //k_set_text('stock_text_v3','');
                  } 

                    if (kplus=='Plus'){
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                  //+' Store </P><P>In-person pickup not available </p>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c3(get_k_data('stock_text_v2','numv10'))+' – '+k_time_c3(get_k_data('stock_text_v2','numv11'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv10'))+' – '+k_time_c(get_k_data('stock_text_v2','numv11'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv9'))+' – '+k_time(get_k_data('stock_text_v2','numv0'))); //new
                       //k_set_text('stock_text_v3','');
                  } 

                    if (knew=='New'){
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                  //+' Store </P><P>In-person pickup not available </p>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c3(get_k_data('stock_text_v2','numv9'))+' – '+k_time_c3(get_k_data('stock_text_v2','numv0'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv9'))+' – '+k_time_c(get_k_data('stock_text_v2','numv0'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv9'))+' – '+k_time(get_k_data('stock_text_v2','numv0'))); //new
                       //k_set_text('stock_text_v3','');
                  } 
         
                  if (klong=='Long') {
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                  //+' Store </P><P>In-person pickup not available </p>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c3(get_k_data('stock_text_v2','numv7'))+' – '+k_time_c3(get_k_data('stock_text_v2','numv8'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv7'))+' – '+k_time_c(get_k_data('stock_text_v2','numv8'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv7'))+' – '+k_time(get_k_data('stock_text_v2','numv8'))); //long
                       //k_set_text('stock_text_v3','');
                  }

                  if (kgs=='Graduation') {
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                  //+' Store </P><P>In-person pickup not available </p>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c3(get_k_data('stock_text_v2','numv14'))+' – '+k_time_c3(get_k_data('stock_text_v2','numv15'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv14'))+' – '+k_time_c(get_k_data('stock_text_v2','numv15'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv7'))+' – '+k_time(get_k_data('stock_text_v2','numv8'))); //long
                       //k_set_text('stock_text_v3','');
                  }
         
                    if(kcid > 100){
                      //k_set_style('stock_ico_v1','display: contents;');
                      k_set_style('stock_text_v1','display: block;');
                      //k_set_style('stock_ico_v1','display: none;');
                      //k_set_text('stock_text_v1',"In Stock. Ships out in 7 days.");
                      //k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                      k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                        //<P>In-person pickup usually ready in <a style="color: #5c5c5c; font-weight: bold;"> 1 hour 🕐</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv3'))+' – '+k_time_c(get_k_data('stock_text_v2','numv4'))+'</span></p>');
                      //k_set_style('stock_ico_v2','display: none;');
                      //k_set_style('stock_text_v2','display: none;color: #AB6803;');
                      //k_set_style('v2','display: none;color: #c16452;');
                      //k_set_text('stock_text_v3','<input type="hidden" id="order_type" name="properties[Order Type]" value="Ships out in 7 days." form="'+get_k_data('stock_text_v3','formid')+'">');
            		}else if(kcid > v1 && kcid<=100){
                       //k_set_style('stock_ico_v1','display: contents;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;font-size:14.5px;background: #faf2e6;');
                       //k_set_style('v2','display: block;color: #c16452;');
                       k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                        //<P>In-person pickup usually ready in <a style="color: #5c5c5c; font-weight: bold;"> 1 hour 🕐</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv3'))+' – '+k_time_c(get_k_data('stock_text_v2','numv4'))+'</span></p>');
            		   //k_set_text('stock_text_v2',get_k_data('stock_text_v1','titlev1')+'. '+'Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));                       
                       //k_set_text('stock_text_v2','Ready to ship! Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));
                       //k_set_text('stock_text_v3','<input type="hidden" id="order_type" name="properties[Order Type]" value="In Stock" form="'+get_k_data('stock_text_v3','formid')+'">');
            		}
            		
            		if(kcid<=v1 && kcid>=v2){
                       //k_set_style('stock_ico_v1','display: contents;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;font-size:14.5px;background: #faf2e6;');
                       //k_set_style('v2','display: block;color: #c16452;');
                       k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                        //<P>In-person pickup usually ready in <a style="color: #5c5c5c; font-weight: bold;"> 1 hour 🕐</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv3'))+' – '+k_time_c(get_k_data('stock_text_v2','numv4'))+'</span></p>');
            		   //k_set_text('stock_text_v2',get_k_data('stock_text_v1','titlev2',kcid)+'. '+'Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));                       
                       //k_set_text('stock_text_v2','Ready to ship! Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));
                       //k_set_text('stock_text_v3','<input type="hidden" id="order_type" name="properties[Order Type]" value="In Stock" form="'+get_k_data('stock_text_v3','formid')+'">');
            		}
            		
            		if(kcid < v2 && kcid>0){
                       //k_set_style('stock_ico_v1','display: contents;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;font-size:14.5px;background: #faf2e6;');
                       //k_set_style('v2','display: block;color: #c16452;');
                       k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                        //<P>In-person pickup usually ready in <a style="color: #5c5c5c; font-weight: bold;"> 1 hour 🕐</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_c(get_k_data('stock_text_v2','numv3'))+' – '+k_time_c(get_k_data('stock_text_v2','numv4'))+'</span></p>');
            		   //k_set_text('stock_text_v2',get_k_data('stock_text_v1','titlev3',kcid)+'. '+'Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));                      
                       //k_set_text('stock_text_v2','Ready to ship! Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));
                       //k_set_text('stock_text_v3','<input type="hidden" id="order_type" name="properties[Order Type]" value="In Stock" form="'+get_k_data('stock_text_v3','formid')+'">');
            		}                      
                      
                    }
                      
                    else {                              

                    if(kcid < 1){
                       //k_set_style('stock_ico_v1','display: flex;background: #faf2e6;text-indent:30px;');
                       k_set_style('stock_text_v1','display: block;');                       
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: block;color: #AB6803;background: #faf2e6;');
                       //k_set_style('stock_text_v3','display: block;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv5'))+' – '+k_time(get_k_data('stock_text_v2','numv6')));                        
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                 //+' Store </P><P>In-person pickup not available </p>'
                                 //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_3(get_k_data('stock_text_v2','numv5'))+' – '+k_time_3(get_k_data('stock_text_v2','numv6'))+' </span></p>'
                                 '<p>In-person pickup is currently unavailable</p>'
                                 +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv5'))+' – '+k_time(get_k_data('stock_text_v2','numv6'))+'</span></p>');                                                                  
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv5'))+' – '+k_time(get_k_data('stock_text_v2','numv6')));
                       //k_set_text('stock_text_v3','');
            		}


                    if (kplus=='Delay'){
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                  //+' Store </P><P>In-person pickup not available </p>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_3(get_k_data('stock_text_v2','numv12'))+' – '+k_time_3(get_k_data('stock_text_v2','numv13'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv12'))+' – '+k_time(get_k_data('stock_text_v2','numv13'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv9'))+' – '+k_time(get_k_data('stock_text_v2','numv0'))); //new
                       //k_set_text('stock_text_v3','');
                  } 

                    if (kplus=='Plus'){
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                  //+' Store </P><P>In-person pickup not available </p>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_3(get_k_data('stock_text_v2','numv10'))+' – '+k_time_3(get_k_data('stock_text_v2','numv11'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv10'))+' – '+k_time(get_k_data('stock_text_v2','numv11'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv9'))+' – '+k_time(get_k_data('stock_text_v2','numv0'))); //new
                       //k_set_text('stock_text_v3','');
                  } 

                    if (knew=='New'){
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',//'<p></p><p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a>'
                                  //+' Store </P><P>In-person pickup not available </p>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_3(get_k_data('stock_text_v2','numv9'))+' – '+k_time_3(get_k_data('stock_text_v2','numv0'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv9'))+' – '+k_time(get_k_data('stock_text_v2','numv0'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv9'))+' – '+k_time(get_k_data('stock_text_v2','numv0'))); //new
                       //k_set_text('stock_text_v3','');
                  } 
         
                  if (klong=='Long') {
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',
                        //<p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a> Store </P>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_3(get_k_data('stock_text_v2','numv7'))+' – '+k_time_3(get_k_data('stock_text_v2','numv8'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv7'))+' – '+k_time(get_k_data('stock_text_v2','numv8'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv7'))+' – '+k_time(get_k_data('stock_text_v2','numv8'))); //long
                       //k_set_text('stock_text_v3','');
                  }

                  if (kgs=='Graduation') {
                       //k_set_style('stock_ico_v1','display: none;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;background: #faf2e6;');
                       //k_set_style('v2','display: block;');
            		   //k_set_text('stock_text_v1','');
                       k_set_text('stock_text_v1',
                        //<p>Book an appointment at <a href="https://www.kissprom.com/pages/book-an-appointment" target="_self" title="Book An Appointment" style="color: #5c5c5c;font-weight: bold;"> 💋KISSPROM </a> Store </P>'
                                  //'<p></p><p> In-person pickup estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time_3(get_k_data('stock_text_v2','numv14'))+' – '+k_time_3(get_k_data('stock_text_v2','numv15'))+' </span></p>'
                                  '<p>In-person pickup is currently unavailable</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv14'))+' – '+k_time(get_k_data('stock_text_v2','numv15'))+'</span></p>');
                       //k_set_text('stock_text_v2','Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv7'))+' – '+k_time(get_k_data('stock_text_v2','numv8'))); //long
                       //k_set_text('stock_text_v3','');
                  }
         
                    if(kcid > 100){
                      //k_set_style('stock_ico_v1','display: contents;');
                      k_set_style('stock_text_v1','display: block;');
                      //k_set_style('stock_ico_v1','display: none;');
                      //k_set_text('stock_text_v1',"In Stock. Ships out in 7 days.");
                      k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                        //<P>In-person pickup usually ready in <a style="color: #5c5c5c; font-weight: bold;"> 1 hour 🕐</p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4'))+'</span></p>');
                      //k_set_style('stock_ico_v2','display: none;');
                      //k_set_style('stock_text_v2','display: none;color: #AB6803;');
                      //k_set_style('v2','display: none;color: #c16452;');
                      //k_set_text('stock_text_v3','<input type="hidden" id="order_type" name="properties[Order Type]" value="Ships out in 7 days." form="'+get_k_data('stock_text_v3','formid')+'">');
            		}else if(kcid > v1 && kcid<=100){
                       //k_set_style('stock_ico_v1','display: contents;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;font-size:14.5px;background: #faf2e6;');
                       //k_set_style('v2','display: block;color: #c16452;');
                       k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                        //<P>In-person pickup usually ready in <a style="color: #5c5c5c; font-weight: bold;"> 1 hour 🕐</a></p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4'))+'</span></p>');
            		   //k_set_text('stock_text_v2',get_k_data('stock_text_v1','titlev1')+'. '+'Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));                       
                       //k_set_text('stock_text_v2','Ready to ship! Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));
                       //k_set_text('stock_text_v3','<input type="hidden" id="order_type" name="properties[Order Type]" value="In Stock" form="'+get_k_data('stock_text_v3','formid')+'">');
            		}
            		
            		if(kcid<=v1 && kcid>=v2){
                       //k_set_style('stock_ico_v1','display: contents;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;font-size:14.5px;background: #faf2e6;');
                       //k_set_style('v2','display: block;color: #c16452;');
                       k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                        //<P>In-person pickup usually ready in <a style="color: #5c5c5c; font-weight: bold;"> 1 hour 🕐</a></p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4'))+'</span></p>');
            		   //k_set_text('stock_text_v2',get_k_data('stock_text_v1','titlev2',kcid)+'. '+'Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));                       
                       //k_set_text('stock_text_v2','Ready to ship! Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));
                       //k_set_text('stock_text_v3','<input type="hidden" id="order_type" name="properties[Order Type]" value="In Stock" form="'+get_k_data('stock_text_v3','formid')+'">');
            		}
            		
            		if(kcid < v2 && kcid>0){
                       //k_set_style('stock_ico_v1','display: contents;');
                       k_set_style('stock_text_v1','display: block;');
                       //k_set_style('stock_ico_v2','display: contents;');
                       //k_set_style('stock_text_v2','display: contents;color: #AB6803;font-size:14.5px;background: #faf2e6;');
                       //k_set_style('v2','display: block;color: #c16452;');
                       k_set_text('stock_text_v1','<p>Ship within <span style="color: #5c5c5c; font-weight: bold;">24 Business HRS</span> (for U.S. only, excluding holidays.)</p>'
                        //<P>In-person pickup usually ready in <a style="color: #5c5c5c; font-weight: bold;"> 1 hour 🕐</a></p>'
                                  +'<p>Express shipping estimated by <span style="color: #5c5c5c; font-weight: bold;">'+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4'))+'</span></p>');
            		   //k_set_text('stock_text_v2',get_k_data('stock_text_v1','titlev3',kcid)+'. '+'Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));                      
                       //k_set_text('stock_text_v2','Ready to ship! Express shipping estimated by '+k_time(get_k_data('stock_text_v2','numv3'))+' – '+k_time(get_k_data('stock_text_v2','numv4')));
                       //k_set_text('stock_text_v3','<input type="hidden" id="order_type" name="properties[Order Type]" value="In Stock" form="'+get_k_data('stock_text_v3','formid')+'">');
            		}
       }
          
            		
         }, 100);
  	}

              
              
   k_stock_text(); 

   // 切换颜色或尺码时重新计算文案
   // variantChangeEnd 在 URL 已通过 replaceState 更新后才冒泡到 document，
   // 所以 k_get_Stock / k_get_ids 能正确读到新 variant 参数
   document.addEventListener('variantChangeEnd', function() {
     k_stock_text();
   });


       

  window.k_stock_text = k_stock_text;
  window.k_set_icon = k_set_icon;
})();
